var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 13.75H11.6719C11.4398 13.75 11.25 13.5602 11.25 13.3281V12.4844C11.25 12.2523 11.4398 12.0625 11.6719 12.0625H14.625C15.5566 12.0625 16.3125 11.3066 16.3125 10.375V3.625C16.3125 2.69336 15.5566 1.9375 14.625 1.9375H11.6719C11.4398 1.9375 11.25 1.74766 11.25 1.51562V0.671875C11.25 0.439844 11.4398 0.25 11.6719 0.25H14.625C16.4883 0.25 18 1.76172 18 3.625V10.375C18 12.2383 16.4883 13.75 14.625 13.75ZM5.87461 0.935547L5.18555 1.62461C5.0168 1.79336 5.02031 2.06406 5.19258 2.22578L9.16875 6.08594H0.421875C0.189844 6.08594 0 6.27578 0 6.50781V7.49219C0 7.72422 0.189844 7.91406 0.421875 7.91406H9.16875L5.19258 11.7707C5.02383 11.9359 5.02031 12.2066 5.18555 12.3719L5.87461 13.0609C6.03984 13.2262 6.30703 13.2262 6.47227 13.0609L12.252 7.29531C12.4172 7.13008 12.4172 6.86289 12.252 6.69766L6.47227 0.932031C6.30703 0.770313 6.03984 0.770312 5.87461 0.935547Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign-in.afbc4a97.svg";
export { ForwardRef as ReactComponent };